<script lang="ts">
    //import {ASSET_URL} from "../config";

    import FileUploadBtn from "./FileUploadBtn.svelte";
    import SingleSelectDropdown from "./SingleSelectDropdown.svelte";
    import MultiSelectDropdown from "./MultiSelectDropdown.svelte";
    import {myStore,entityStore} from "../../stores.js";
    import { createEventDispatcher } from 'svelte';
    import {ASSET_URL} from "../../config";
    import UploadInfoBox from "./UploadInfoBox.svelte";
    const dispatch = createEventDispatcher();
    export let index;

    export let disabled;

    export let title;

    let typeValues = [
        { value: 'AGENT', label: 'Agent communal' },
        { value: 'EXTERN', label: 'Prestataire externe' },
    ];
/*

 $myStore.setFields(`communities.${index}.community_id`,community_id.value); //convertion needed before post
    }      //console.log("availableCommunities = ", $entityStore.availableCommunities);

    //TODO, fetch from server
    let filteredCommunities =  [
        { value: 'one', label: 'One' },
        { value: 'two', label: 'Two' },
        { value: 'three', label: 'Three' },
    ];
    */

    function remove(){
        dispatch('remove');
    }

    function communitiesSelected(event) {

        console.log("get event ====>",event);


        let selection = [];

        if(event.detail.value){

            selection = event.detail.value.map(c => {
                //$myStore.addField(`communities`,c, communities.length + 1);
                return c.value;
            });
        }



        console.log("set val ====>",selection);
        $myStore.setData(`step3.pactCoordinators.${index}.communities`, selection);

    }

</script>

<div class="coordinator-box">

    <div class="box-header">
        <h4>
            {#if title} {title} {/if}
        </h4>
        {#if index !== 0}
            <div class="box-remove-btn" on:click={remove}>
                <div>  <img src="{ASSET_URL}/assets/img/icons/close-white.svg"/></div>

            </div>
        {/if}
    </div>
    <div class="box-content">

        <div class="custom-row mb-3">
            <div class="custom-col-6">
                <input {disabled} class="w-100" type="text" name="step3.pactCoordinators.{index}.firstname" placeholder="Prénom" class:error={$myStore.errors.step3?.pactCoordinators[index]?.firstname }/>
            </div>
            <div class="custom-col-6">
                <input {disabled} class="w-100" type="text" name="step3.pactCoordinators.{index}.lastname" placeholder="Nom" class:error={$myStore.errors.step3?.pactCoordinators[index]?.lastname}/>
            </div>
        </div>

        <div class="custom-row mb-3">
            <div class="custom-col-12">
                {#if $myStore.data.pactIsSignedBySyndicate}

                    <SingleSelectDropdown disabled={true} placeholder={$myStore?.data?.syndicateName} ></SingleSelectDropdown>
                {:else}

                    <MultiSelectDropdown {disabled} error={$myStore.errors.step3?.pactCoordinators[index]?.communities != null} placeholder="Commune" on:select={communitiesSelected} items={$entityStore.availableCommunities}></MultiSelectDropdown>
                {/if}
            </div>
        </div>


        <div class="custom-row mb-3">
            <div class="custom-col-12">
                <SingleSelectDropdown {disabled} error={$myStore.errors.step3?.pactCoordinators[index]?.type != null} placeholder="Agent communal/Prestataire externe" formField="step3.pactCoordinators.{index}.type" items={typeValues}></SingleSelectDropdown>
            </div>
        </div>

        <div class="custom-row p-0" style="margin:0">

        <!--
            <textarea class="custom-col-12" rows="10"  name="step3.pactCoordinators.{index}.description"
                      placeholder="Description des tâches pour chaque coordinateur·trice désigné·e" class:error={$myStore.errors.step3.pactCoordinators[index]?.description}></textarea>
        </div>
        -->

            <h4 class="title p-0 mt-3">Annexes à fournir</h4>

                <UploadInfoBox
                        withoutOverlay="true"
                        text="Description des tâches pour chaque coordinateur·trice désigné·e">

                </UploadInfoBox>


        </div>
            <div class="custom-row mt-3 p-0">
                <FileUploadBtn {disabled} fieldName="step3.pactCoordinators.{index}.files" errorClass={$myStore.errors.step3?.pactCoordinators[index]?.files}></FileUploadBtn>
            </div>



    </div>

</div>


<style lang="scss">

  .coordinator-box {

    background: $secondary-color;
    padding: 1.5rem;
    border-radius: 9px;
    color: #F8F7F7;
    max-width: 600px;
    //min-width:298px;
    flex: 1 1 400px;
    box-sizing: border-box;

    .box-header {

      display:flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        margin: 0;
        padding: 0;
      }

      .box-remove-btn{

      }


      margin-bottom: 1rem;

    }
  }


</style>
